import type { SeoData } from './seo';

function ensureMeta(attr: 'name' | 'property', key: string): HTMLMetaElement {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
}

function setMetaName(name: string, content: string) {
  ensureMeta('name', name).setAttribute('content', content);
}

function setMetaProperty(property: string, content: string) {
  ensureMeta('property', property).setAttribute('content', content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applyHead(seo: SeoData) {
  document.title = seo.title;
  setMetaName('description', seo.description);
  setMetaName('keywords', seo.keywords);
  setMetaName('robots', seo.indexable ? 'index, follow' : 'noindex, nofollow');
  if (seo.canonical) {
    setCanonical(seo.canonical);
  }
  setMetaProperty('og:title', seo.title);
  setMetaProperty('og:description', seo.description);
  if (seo.canonical) {
    setMetaProperty('og:url', seo.canonical);
  }
  setMetaProperty('og:type', seo.type === 'article' ? 'article' : 'website');
  setMetaName('twitter:title', seo.title);
  setMetaName('twitter:description', seo.description);
}